import script from "./CanvasOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./CanvasOrganism.vue?vue&type=script&setup=true&lang=js"

import "./CanvasOrganism.vue?vue&type=style&index=0&id=d3c3db06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3c3db06"]])

export default __exports__